<script setup lang="ts">
import type { LocationItem } from '#shared/types/location'

const props = defineProps<{ location: LocationItem }>()

const emit = defineEmits<{
  (event: 'open', location: LocationItem): void
}>()

const handleOpen = (): void => {
  emit('open', props.location)
}
</script>

<template>
  <button type="button" class="group block w-full cursor-pointer" @click="handleOpen">
    <ContactLocationCardContent :location />
  </button>
</template>
